export default __webpack_public_path__ + "static/4-44582f820708dbbd2b552d2436fe250e.png";